import { FC, useEffect, useState } from "react";
import { SalesAutomationWrapper } from "./SalesAutomation.styled";
import { getSalesAutomationData } from "cms/helpers";
import { StructuredText } from "react-datocms";
import { useLocation } from "react-router-dom";
import { MarketingGreenButtonWrapper } from "components/MarketingHomepage/MarketingHomepage.styled";
import { TwoButtonDiv } from "shared/shared_components/components";

interface SalesAutomationProps {}

interface Section {
  title: string;
  description: {
    value: any;
  };
  image: {
    url: string;
  };
}
interface SalesAutomationData {
  title: string;  
  sections: Section[];
  introParagraph: string;
}

const SalesAutomation: FC<SalesAutomationProps> = () => {
  const [data, setData] = useState<SalesAutomationData>();
  const { hash } = useLocation();

  useEffect(() => {
    const getData = async () => {
      let response = await getSalesAutomationData();
      console.log(response);
      setData(response?.salesAutomation);
    };
    getData();
  }, []);

  useEffect(() => {
    const hash = window.location.hash.substring(1); // Remove the '#' from the hash
    if (hash) {
      const sectionElement = document.getElementById(hash);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [data, hash]);

  return (
    <SalesAutomationWrapper>
      <h1>{data?.title}</h1>
      <h4 className="intro-paragraph">{data?.introParagraph}</h4>
      <TwoButtonDiv
        rightLink="/contact-us"
        rightText="Contact Sales"
        leftLink="/signup"
        leftText="Get started for free"
      />
      <div className="sections-wrapper">
        {data?.sections?.map((section: Section, index: number) => {
          //if index is odd, reverse the order
          if (index % 2 === 1) {
            return (
              <div
                className="section-wrapper-right"
                id={`section-${index}`}
                key={index}
              >
                <div className="flex-wrapper-right">
                  <img src={section.image?.url} />
                  <div className="text-right">
                    <h2>{section.title}</h2>
                    <StructuredText data={section.description?.value} />
                    <MarketingGreenButtonWrapper
                      onClick={() => {
                        window.location.assign(
                          "/contact-us"
                        );
                      }}
                      width={250}
                    >
                      Contact Sales
                    </MarketingGreenButtonWrapper>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div
                className="section-wrapper"
                id={`section-${index}`}
                key={index}
              >
                <div className="flex-wrapper">
                  <div className="text">
                    <h2>{section.title}</h2>
                    <StructuredText data={section.description?.value} />
                    <MarketingGreenButtonWrapper
                      onClick={() => {
                        window.location.assign(
                          "/contact-us"
                        );
                      }}
                      width={250}
                    >
                      Contact Sales
                    </MarketingGreenButtonWrapper>
                  </div>
                  <img src={section.image?.url} />
                </div>
              </div>
            );
          }
        })}
      </div>
    </SalesAutomationWrapper>
  );
};

export default SalesAutomation;
